import { useState, useEffect } from 'react';

interface NavItem {
  label: string;
  href: string;
}

const navItems: NavItem[] = [
  { label: '爆料合集', href: '#index' },
  { label: '视频速递', href: '#media' },
  { label: '热度榜单', href: '#ranking' },
  { label: '平台特色', href: '#features' },
  { label: '投稿通道', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 font-bold text-lg">
              瓜
            </span>
            <span className="font-heading text-xl text-foreground-900 whitespace-nowrap">
              每日大瓜
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-accent-600 transition-colors rounded-md whitespace-nowrap cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-accent-600 transition-colors rounded-md whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <nav className="px-4 py-3 flex flex-col gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                setMenuOpen(false);
              }}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-accent-600 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-accent-600 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}